import { useState, useEffect } from 'react'
import { EnableDisableTag, Heading } from '../components/common/atoms'
import { backToOfficeLow } from '../assets/images';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { appApi } from '../services';
import { successOrFailureToaster } from '../components/common/atoms/messages';
import { ConfirmModal } from '../components/modals';
import { dsButtonGhostBrand, joinButtonClasses } from '../utils/buttonStyles';

const AccountSettings = () => {
  let history = useHistory()
  const [enabled, setEnabled] = useState(false);
  const [showDisableConfirmModal, setDisableConfirmModal] = useState(false)
  const role = ['CSMMaster', 'CSM'].includes(sessionStorage.getItem('role'));

  useEffect(() => {
    appApi.mfaDetail({},
      (res) => {
        if(res?.data?.mfa_enabled) setEnabled(true)
      },
      (e) => {
        successOrFailureToaster({message: 'something went wrong!', type: 'fail'})
      })
  },[enabled])
  

  const btnHandler = () => {
    if(enabled && !role) {
      appApi.mfaDelete({},
        (res) => {
          let msg = res?.data?.message
          if(!res?.data?.mfa_enabled) setEnabled(false)
          successOrFailureToaster({message: msg})
        },
        (e) => {
          successOrFailureToaster({message: 'something went wrong!', type: 'fail'})
        })
    }
    else {
      history.push('account-settings/mfa-method')
    }
    setDisableConfirmModal(!showDisableConfirmModal)
  }

  const toggleDisableConfirmModal = () => {
    if(!role) setDisableConfirmModal(!showDisableConfirmModal)
    else return
  }

  return (
    <div>
      <div>
        <Heading mainHeading='Account Settings' subClasses='mt-1 text-sm text-gray-600' />
      </div>
      <div
        className={`bg-white rounded-md shadow-md p-6 w-96 mt-10`}
      >
        <div className="flex justify-between items-start">
          <img className='h-16' src={backToOfficeLow} alt='multi factor authentication icon' />
          <div className='flex items-center gap-1'>
            <EnableDisableTag enabled={enabled} />
            <ConfirmModal
              visible={showDisableConfirmModal}
              heading={['Are you sure you want to disable ', <strong>Multi Factor Authentication ?</strong>]}
              closeHandler={toggleDisableConfirmModal}
              handler={btnHandler}
            />
          </div>
        </div>
        <Heading mainHeading='Multi Factor Authentication' subHeading='Enable multi factor authentication' mainClasses='font-fig-extrabold text-xl font-medium leading-tight text-gray-900 mb-2' subClasses='text-sm text-gray-600' classes='mt-3' />
        { !role &&
          <button className={joinButtonClasses(dsButtonGhostBrand, 'mt-4 h-11 w-full', role && enabled && 'cursor-not-allowed')}
          onClick={enabled ? toggleDisableConfirmModal : btnHandler}
        >
          {enabled ? 'Disable Multi Factor Authentication' : 'Enable Multi Factor Authentication'}
        </button>}
      </div>
    </div>

  )
}

export default AccountSettings
